import { Component, createRef, ReactNode } from 'react';
import { NSBoxSensitive, NSColumn } from 'namirasoft-site-react';
import { NSARouterMakerResult } from 'namirasoft-account-react';

export interface PasswordFormProps extends NSARouterMakerResult
{
    require_current_password?: boolean;
    children?: ReactNode;
}

class PasswordForm extends Component<PasswordFormProps>
{
    private NSBoxSensitive_CurrentPassword = createRef<NSBoxSensitive>();
    private NSBoxSensitive_Password = createRef<NSBoxSensitive>();
    private NSBoxSensitive_ConfirmPassword = createRef<NSBoxSensitive>();

    constructor(props: PasswordFormProps)
    {
        super(props);
        this.getPasswords = this.getPasswords.bind(this);
    }

    getPasswords()
    {
        try
        {
            let current = this.NSBoxSensitive_CurrentPassword.current?.getValue() ?? "";
            let password = this.NSBoxSensitive_Password.current?.getValue() ?? "";
            let confirm = this.NSBoxSensitive_ConfirmPassword.current?.getValue() ?? "";
            return { current, password, confirm };
        }
        catch (error)
        {
            return undefined;
        }
    }

    override render()
    {
        return (
            <NSColumn style={{ padding: "0 0.5rem", alignItems: "center" }}>
                {this.props.children}
                {
                    this.props.require_current_password &&
                    <NSBoxSensitive
                        {...this.props}
                        ref={this.NSBoxSensitive_CurrentPassword}
                        title="Current Master Password"
                        required
                        auto_complete="new-password"
                    />
                }
                <NSBoxSensitive
                    {...this.props}
                    ref={this.NSBoxSensitive_Password}
                    title="New Master Password"
                    required
                    auto_complete="new-password"
                />
                <NSBoxSensitive
                    {...this.props}
                    ref={this.NSBoxSensitive_ConfirmPassword}
                    title="Confirm Master Password"
                    required
                    validator={(_, confirm_password) =>
                    {
                        let password = this.NSBoxSensitive_Password.current?.getValue();
                        return password !== confirm_password ? "Passwords do not match." : null;
                    }}
                />
            </NSColumn>
        )
    }
}

export default PasswordForm;